<template>
    <div class="innerBox">
  
      <h1>Outstanding Estimation</h1>
  
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox" style="padding:0 12.5%">
          <div class="col row">
            <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Cari</label>
              <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
            </div>
            <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Tanggal</label>
              <flat-pickr
                v-model="selected.date"
                :config="rangeConfig"
                placeholder="Pilih Tanggal"
              ></flat-pickr>
            </div>
            <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
            </div>
          </div>
        </div>
      </panel>
  
      <vue-universal-table
        api_url="/api/v1/workorder/listing/outstanding-estimations"
        :fields="vue_universal_table.fields"
        :special_buttons="vue_universal_table.special_buttons"
        :disable_sort="true"
        :update="vue_universal_table.update"
        :filter="filter"
        :export_config="vue_universal_table.export_config"
      ></vue-universal-table>
  
    </div>
  </template>
  
  <script>  
    export default {
      data () {
        return {
          mobile : this.isMobile(),
          modal : {
            view : false,
          },
          rangeConfig: {
            mode: 'range',
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          detailId : '',
          selected : {
            date : '',
          },
          filter : {
            search : ''
          },
          vue_universal_table : {
            fields : [
                {
                    title : 'Work Order ID',
                    variable : 'form_code'
                },
                {
                    title : 'Nama Pelanggan',
                    variable : 'customer_name'
                },
                {
                    title : 'No Polisi',
                    variable : 'registration'
                },
                {
                    title : 'CSO',
                    variable : 'CSO'
                },
                {
                    title : 'Dibuat Pada',
                    variable : 'created_at'
                }
            ],
            special_buttons : ['exportToExcel'],
            update : 0,
            export_config : {
              name : 'Outstanding Estimation',
              type : 'xlsx',
              all : true
            },
          },
          dummyData : null,
        }
      },
      mounted () {
        this.generateData()
      },
      watch : {
        'selected.date'(){
          var date = this.selected.date.split(" to ");
          this.filter.start = date[0]
          this.filter.end = date[1]
        }
      },
      methods : {
        viewDetail(a){
          console.log(JSON.parse(a).form_code);
          this.detailId = JSON.parse(a).form_code;
          this.modal.view = true;
        },
        generateData(){
            var names = ['Apple', 'Orange', 'Lemon', 'Kiwi', 'Pear']
            var dummy = []
            for(var i = 0; i < 15; i++){
                dummy.push({
                    woNumber : this.randomInt(1000000, 10000000),
                    total_sparepart : this.randomInt(1, 10),
                    total_price : this.randomInt(100000, 10000000),
                    insurance_name : names[this.randomInt(0,4)],
                    customer_name : names[this.randomInt(0,4)],
                })
            }
            this.dummyData = dummy
        },
      }
    }
  </script>
  
  <style scoped>
  
  </style>